<template>
    <v-list-item :to="{ name: 'M_Whos on first' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-format-list-numbered</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Who's on first</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemWhosOnFirst',
    props: {
        disabled: Boolean,
    }
}
</script>